import { Link } from 'react-router-dom'

// All marketing surfaces live on app.gamedevbuddy.com after the
// consolidation. Footer links are in-app (React Router) except:
// - /docs → Docusaurus subdomain (still a separate site)
// - Discord → external community link (target=_blank)
const linkClass =
  'text-muted-godlike hover:text-accent-godlike text-sm transition-colors'

export default function Footer() {
  return (
    <footer className="bg-dark-2 border-t border-[var(--color-dark-4)] mt-20">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/images/gdb-logo.png"
                alt="GameDevBuddy"
                width={40}
                height={40}
                className="w-10 h-10 object-contain"
              />
              {/* Heading font — font-family set by .marketing-chrome h* via inline var */}
              <span
                className="text-xl text-white"
                style={{ fontFamily: 'var(--font-heading)' }}
              >
                GameDevBuddy
              </span>
            </div>
            <p className="text-muted-godlike text-sm">
              Game development tools for creators of all sizes.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-white mb-4">Product</h4>
            <ul className="space-y-2">
              <li><Link to="/modules" className={linkClass}>Modules</Link></li>
              <li><Link to="/faqs" className={linkClass}>FAQs</Link></li>
              <li><Link to="/roadmap" className={linkClass}>Roadmap</Link></li>
              <li><Link to="/changelog" className={linkClass}>Changelog</Link></li>
              <li><Link to="/updates" className={linkClass}>Updates</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-white mb-4">Resources</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/docs" className={linkClass}>
                  Documentation
                </Link>
              </li>
              <li><Link to="/support" className={linkClass}>Support</Link></li>
              <li><Link to="/news" className={linkClass}>News</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white mb-4">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className={linkClass}>About</Link></li>
              <li><Link to="/contact" className={linkClass}>Contact</Link></li>
              <li><Link to="/privacy" className={linkClass}>Privacy</Link></li>
              <li><Link to="/terms" className={linkClass}>Terms</Link></li>
              <li><Link to="/impressum" className={linkClass}>Impressum</Link></li>
            </ul>
          </div>
        </div>

        <div className="divider-godlike mt-0 mb-0" style={{ margin: '2rem 0' }} />
        <div className="text-center">
          <p className="text-muted-godlike text-sm">
            &copy; 2026 GameDevBuddy. Built with care for game developers.
          </p>
        </div>
      </div>
    </footer>
  )
}
